import { render, staticRenderFns } from "./SelectComponent.vue?vue&type=template&id=d466dace&scoped=true"
import script from "./SelectComponent.vue?vue&type=script&lang=js"
export * from "./SelectComponent.vue?vue&type=script&lang=js"
import style0 from "./SelectComponent.vue?vue&type=style&index=0&id=d466dace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d466dace",
  null
  
)

export default component.exports